var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestionMarkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4602",
    "data-name": "Path 4602",
    d: "M0-19.25a11,11,0,0,0-11,11,11,11,0,0,0,11,11,11,11,0,0,0,11-11A11,11,0,0,0,0-19.25ZM0,.688A8.947,8.947,0,0,1-8.937-8.25,8.947,8.947,0,0,1,0-17.187,8.947,8.947,0,0,1,8.938-8.25,8.947,8.947,0,0,1,0,.688Zm0-5.5A1.357,1.357,0,0,0-1.375-3.437,1.334,1.334,0,0,0,0-2.062,1.382,1.382,0,0,0,1.375-3.437,1.382,1.382,0,0,0,0-4.812ZM1.422-13.75h-2.2a2.989,2.989,0,0,0-3.008,3.008A1.046,1.046,0,0,0-2.75-9.711a1.046,1.046,0,0,0,1.031-1.031.921.921,0,0,1,.907-.945h2.2a1,1,0,0,1,1.023.945.862.862,0,0,1-.473.778l-2.449,1.5a1.06,1.06,0,0,0-.516.9v.688A1.046,1.046,0,0,0,0-5.844,1.046,1.046,0,0,0,1.031-6.875v-.086l1.938-1.2A3.066,3.066,0,0,0,4.43-10.742,2.942,2.942,0,0,0,1.422-13.75Z",
    transform: "translate(11 19.25)",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkWhite);
export default __webpack_public_path__ + "static/media/question-mark-white.a815ca98e17e5098ed21a3dd2f4d22c8.svg";
export { ForwardRef as ReactComponent };